
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/site/tools/email-link-checker",
      function () {
        return require("private-next-pages/site/tools/email-link-checker.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/site/tools/email-link-checker"])
      });
    }
  